import React from 'react';

import ToastBox from './ToastBox';
import {ToastConfigParams} from 'react-native-toast-message';

import {strings} from 'asset/constant';

const {successTitle, errorTitle, warningTitle, infoTitle} = strings;

interface PropsT {}
export const config = {
  success: (props: ToastConfigParams<PropsT>) => {
    const {text1, text2, type} = props;

    return (
      <ToastBox title={text1 || successTitle} message={text2} type={type} />
    );
  },
  error: (props: ToastConfigParams<PropsT>) => {
    const {text1, text2, type} = props;
    return <ToastBox title={text1 || errorTitle} message={text2} type={type} />;
  },
  warning: (props: ToastConfigParams<PropsT>) => {
    const {text1, text2, type} = props;
    return (
      <ToastBox title={text1 || warningTitle} message={text2} type={type} />
    );
  },
  info: (props: ToastConfigParams<PropsT>) => {
    const {text1, text2, type} = props;
    return <ToastBox title={text1 || infoTitle} message={text2} type={type} />;
  },
};
